import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ba8c9956"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft26 boldFont"
}, "欢迎登录", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "手机号", -1));
const _hoisted_3 = {
  key: 0,
  class: "error"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14"
}, "密码", -1));
const _hoisted_5 = {
  key: 1,
  class: "error"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/c42edffb-0d45-8912-77d2-03b37d44e7a8.svg",
  class: "ml4 sqr14"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/2025/07/18/pc-logo.png",
  style: {
    "width": "35px",
    "height": "38px",
    "margin-top": "8px"
  }
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft26 ml8"
}, "速记星超常儿童智力甄别和训练系统", -1));
const _hoisted_9 = {
  class: "flex flex-col flex items-center justify-center",
  style: {
    "position": "fixed",
    "left": "12px",
    "top": "50%"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/c42edffb-0d45-8912-77d2-03b37d44e7a8.svg",
  class: "sqr14 ml4"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/812f4453-7649-5975-de5c-b14ecbdedf46.png",
  style: {
    "width": "100px"
  }
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请使用微信扫码联系", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
    class: "login-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "login-inner-box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 16
      }, {
        default: _withCtx(() => [_createTextVNode("   ")]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        class: "login-inner-box-right flex flex-col flex items-center justify-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "login-right-title"
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "wd100 pd32 flex flex-col mt26"
        }, {
          default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_input, {
            class: "wd100 input-area",
            size: "large",
            placeholder: "请输入账号",
            modelValue: $data.loginModel.account,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.loginModel.account = $event),
            onKeyup: _withKeys($options.doLogin, ["enter"]),
            "prefix-icon": "user"
          }, null, 8, ["modelValue", "onKeyup"]), $data.accountError ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($data.accountError), 1)) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_el_input, {
            class: "wd100 input-area",
            size: "large",
            placeholder: "请输入密码",
            modelValue: $data.loginModel.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loginModel.password = $event),
            onKeyup: _withKeys($options.doLogin, ["enter"]),
            "prefix-icon": "lock",
            type: "password"
          }, null, 8, ["modelValue", "onKeyup"]), $data.passwordError ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($data.passwordError), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            class: "wd100 mt32 loginBtn",
            type: "primary",
            size: "large",
            onClick: $options.doLogin
          }, {
            default: _withCtx(() => [_createTextVNode("登录")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_row, {
            class: "flex justify-end items-center mt12"
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: {
                "font-size": "12px"
              },
              class: "ptr",
              onClick: _cache[2] || (_cache[2] = $event => $data.cooVisible = true)
            }, "合作分销"), _hoisted_6]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center",
    style: {
      "position": "absolute",
      "top": "15%",
      "left": "10%"
    }
  }, {
    default: _withCtx(() => [_hoisted_7, _hoisted_8]),
    _: 1
  }), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: "https://cdn.waityou.online/775813e4-6f89-42d0-b5b0-1ccd06186c18.svg",
    class: "ptr",
    onClick: _cache[3] || (_cache[3] = $event => $data.cooVisible = true),
    style: {
      "width": "40px"
    }
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      style: {
        "font-size": "12px"
      },
      class: "ptr",
      onClick: _cache[4] || (_cache[4] = $event => $data.cooVisible = true)
    }, "合作分销"), _hoisted_10]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    title: "合作分销",
    "visible-control": $data.cooVisible,
    width: "500px",
    onClose: _cache[5] || (_cache[5] = $event => $data.cooVisible = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "flex items-center justify-center flex flex-col vpd20"
    }, {
      default: _withCtx(() => [_hoisted_11, _hoisted_12]),
      _: 1
    })]),
    _: 1
  }, 8, ["visible-control"])], 64);
}